import styled from "styled-components";
export const Icon = styled.img`
    height: 7vw;
    width: 7vw;
    margin: 1.5vw;
    @media only screen and (min-width: 600px) {
      height: 2vw;
      width: 2vw;
    }
    @media only screen and (min-width: 1000px) {
      height: 1.75rem;
      width: 1.75rem;
    }
    
  `,

  PaddingBox = styled.a`
    display: flex;
    justify-content: center;
    padding: 1vw;
    border: 2px solid #29a9e1;
    box-sizing: border-box;
    background: linear-gradient(180deg, #083f88 -5.1%, #00aae4 88.78%);
    border-radius: 50%;
    align-items: center;
    margin: 0 0.5rem;
    text-decoration: none;
    transition: background 0.4s;
    
    &:hover {
      background: linear-gradient(180deg, #00aae4 -5.1%, #083f88 88.78%);
    }
    @media only screen and (min-width: 600px) {
      margin: 0rem 0.15rem;
      padding: 1vw;
    }
    @media only screen and (min-width: 1000px) {
      margin: 0rem 0.25rem;
      padding: 1vw;
    }
    
  `;
